// Player actions
export const SET_PLAY_STATE = 'SET_PLAY_STATE'
export const SET_DEMO_MODE = 'SET_DEMO_MODE'
export const SET_PLAYED_TIME = 'SET_PLAYED_TIME'
export const RESET_PAIN_LEVELS_AND_SESSION_ID = 'RESET_PAIN_LEVELS_AND_SESSION_ID'
export const RESET_SONG_INFO = 'RESET_SONG_INFO'
export const SET_IMMERSIVE_VIDEO = 'SET_IMMERSIVE_VIDEO'
export const SET_PAIN_AFTER_LEVEL = 'SET_PAIN_AFTER_LEVEL'
export const SET_PAIN_BEFORE_LEVEL = 'SET_PAIN_BEFORE_LEVEL'
export const SET_SESSION_ID = 'SET_SESSION_ID'
export const SET_INDICATION_TYPE = 'SET_INDICATION_TYPE'
export const SET_SONG_ID = 'SET_SONG_ID'
export const SET_ALL_SONGS = 'SET_ALL_SONGS'
export const SET_ALL_GENRES = 'SET_ALL_GENRES'
export const SET_SONG_INFO = 'SET_SONG_INFO'
export const START_FETCH_GENRES = 'START_FETCH_GENRES'
export const FAIL_FETCH_MUSIC = 'FAIL_FETCH_MUSIC'
export const ADD_TO_PLAYLIST = 'ADD_TO_PLAYLIST'
export const REMOVE_FROM_PLAYLIST = 'REMOVE_FROM_PLAYLIST'
export const SET_PLAYLIST = 'SET_PLAYLIST'
export const PLAY_PLAYLIST = 'PLAY_PLAYLIST'
export const REORDER_PLAYLIST = 'REORDER_PLAYLIST'
export const SET_SONG_SESSION_INFO = 'SET_SONG_SESSION_INFO'
export const SET_END_EVENT = 'SET_END_EVENT'
export const START_FETCH_FROM_REMOTE = 'START_FETCH_FROM_REMOTE'
export const SET_ALL_LOCAL_GENRES = 'SET_ALL_LOCAL_GENRES'
export const SET_ALL_LOCAL_SONGS = 'SET_ALL_LOCAL_SONGS'
export const SET_VOLUME = 'SET_VOLUME'
export const SET_SESSION_ONLINE = 'SET_SESSION_ONLINE'
export const SET_SESSION_DB = 'SET_SESSION_DB'
export const SET_SESSION_DB_TABLE = 'SET_SESSION_DB_TABLE'

// History actions
export const INITIALIZE_HISTORY = 'INITIALIZE_HISTORY'
export const UPDATE_HISTORY = 'UPDATE_HISTORY'

// Alarm action
export const ADD_ALARM = 'ADD_ALARM'
export const SET_ALARMS = 'SET_ALARMS'
export const REMOVE_ALARM = 'REMOVE_ALARM'
export const END_ALARM_LAUNCH = 'END_ALARM_LAUNCH'
export const START_ALARM_LAUNCH = 'START_ALARM_LAUNCH'
export const UPDATE_ALARM = 'UPDATE_ALARM'

// Auth actions
export const AUTH_RESET_PASS_SUCCESS = 'AUTH_RESET_PASS_SUCCESS'
export const AUTH_START = 'AUTH_START'
export const AUTH_ERROR_RESET = 'AUTH_ERROR_RESET'
export const AUTH_FAIL = 'AUTH_FAIL'
export const AUTH_SOCIAL_MSG = 'AUTH_SOCIAL_MSG'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_ONLINE_STATE = 'SET_ONLINE_STATE'
export const SET_SAVE_FILES = 'SET_SAVE_FILES'

// Download actions
export const SET_DOWNLOAD_ID = 'SET_DOWNLOAD_ID'
export const SET_DOWNLOAD_PROGRESS = 'SET_DOWNLOAD_PROGRESS'
export const SET_DOWNLOAD_NUMBER = 'SET_DOWNLOAD_NUMBER'
export const DOWNLOAD_SONGS_START = 'DOWNLOAD_SONGS_START'
export const DOWNLOAD_SONGS_FAIL = 'DOWNLOAD_SONGS_FAIL'
export const DOWNLOAD_SONG_SUCCESS = 'DOWNLOAD_SONG_SUCCESS'
export const DOWNLOAD_SONGS_SUCCESS = 'DOWNLOAD_SONGS_SUCCESS'
export const DOWNLOAD_SONG_REMOVE = 'DOWNLOAD_SONG_REMOVE'
export const TOGGLE_DOWNLOAD_IN_BACKGROUND = 'TOGGLE_DOWNLOAD_IN_BACKGROUND'
export const SET_DOWNLOAD_PROMISE = 'SET_DOWNLOAD_PROMISE'
export const INITIALIZE_DOWNLOADED_SONGS = 'INITIALIZE_DOWNLOADED_SONGS'
export const SET_MISSING_SONG_INFO = 'SET_MISSING_SONG_INFO'
export const SET_MISSING_SONG_IMAGE_INFO = 'SET_MISSING_SONG_IMAGE_INFO'
export const SET_MISSING_GENRE_IMAGE_INFO = 'SET_MISSING_GENRE_IMAGE_INFO'
export const DOWNLOAD_COMPANY_LOGO_SUCCESS = 'DOWNLOAD_COMPANY_LOGO_SUCCESS'
export const DOWNLOAD_COMPANY_LOGO_FAIL = 'DOWNLOAD_COMPANY_LOGO_FAIL'
